import { Injectable } from '@angular/core';
// eslint-disable-next-line max-len
import { ServiceGroup } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromServiceGroups from './service-groups.actions';
import { ServiceGroupsState } from './service-groups.interfaces';
import { map } from 'rxjs/operators';
@Injectable()
export class ServiceGroupsEffects {
  
  getServiceGroupsFromServer = createEffect(() => this.dataPersistence.fetch(fromServiceGroups.GET_SERVICE_GROUPS_FROM_SERVER, {
    run: (action: fromServiceGroups.GetServiceGroupsFromServer, state: ServiceGroupsState) => {
      return this.apiService
        .get<ServiceGroup[]>(`v/1/fixed-operations/service-groups`, {
          params: action.payload
        })
        .pipe(
          map(
            serviceGroups =>
              new fromServiceGroups.GetServiceGroupsFromServerSuccess({
                serviceGroups: serviceGroups
              })
          )
        );
    },
    onError: (action: fromServiceGroups.GetServiceGroupsFromServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<ServiceGroupsState>,
    private apiService: ApiService
  ) {}
}
